var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 20 16"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M17.917 0 6.232 12.524 1.61 7.592 0 9.255l6.232 6.595L19.527 1.663 17.917 0Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }